import { ExtractedData } from '@common/types';
import { find } from 'lodash';
import { useMemo } from 'react';
import { FileClassificationScores } from 'broker/components/FilesExplorer/types';
import { toClassificationPercent } from 'broker/components/FilesExplorer/utils/classification-score-utils';

export function useFileClassificationScores(extractedData: ExtractedData | undefined): FileClassificationScores {
  return useMemo(() => {
    const classificationScoresByFileId: FileClassificationScores = new Map();

    if (!extractedData?.fileClassification) {
      return classificationScoresByFileId;
    }

    for (const fileClassification of extractedData.fileClassification) {
      // classification.metadata.scores contains all classification candidates and their scores
      const score = find(fileClassification?.metadata?.scores, { classification: fileClassification.fileType })?.score;

      if (score != null) {
        classificationScoresByFileId.set(fileClassification.boxFileId, toClassificationPercent(score));
      }
    }

    return classificationScoresByFileId;
  }, [extractedData?.fileClassification]);
}
